import { createSlice } from '@reduxjs/toolkit';
import { addNewBankAccount, editBankAccount, getBankAccounts } from './bankService';

const initialState = {
  allBankAccounts: {
    isBankAccountsLoading: null,
    isBankAccountsSuccess: null,
    bankAccountsMessage: null,
    pageCount: 0,
    bankAccounts: [],
  },
  newBankAccount: {
    isBankAccountCreating: null,
    isBankAccountCreated: null,
    bankAccountCreationMsg: null,
  },
  editBankAccount: {
    isEditingBakAccount: null,
    isEditedBankAccount: null,
    bankAccountEditMsg: null
  },
};

const bankSlice = createSlice({
  name: 'bank',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBankAccounts.pending, (state) => {
        state.allBankAccounts = {
          ...initialState.allBankAccounts, // Reset to initial state
          isBankAccountsLoading: true,
          bankAccountsMessage: 'Loading',
        };
      })
      .addCase(getBankAccounts.rejected, (state, action) => {
        state.allBankAccounts = {
          ...initialState.allBankAccounts,
          isBankAccountsLoading: false,
          isBankAccountsSuccess: false,
          bankAccountsMessage: action.payload || 'Error occurred while fetching bankAccounts',
        };
      })
      .addCase(getBankAccounts.fulfilled, (state, action) => {
        state.allBankAccounts = {
          ...initialState.allBankAccounts,
          isBankAccountsLoading: false,
          isBankAccountsSuccess: true,
          pageCount: action.payload.pageCount || 0,
          bankAccounts: action.payload.data || [],
        };
      });

    //BankAccount creating
    builder
      .addCase(addNewBankAccount.pending, (state) => {
        state.newBankAccount = {
          ...initialState.newBankAccount, 
          isBankAccountCreating: true,
          bankAccountCreationMsg: 'Loading',
        };
      })
      .addCase(addNewBankAccount.rejected, (state, action) => {
        state.newBankAccount = {
          ...initialState.newBankAccount,
          isBankAccountCreating: false,
          isBankAccountCreated: false,
          bankAccountCreationMsg: action.payload || 'Error occurred while creating the bankAccount.',
        };
      })
      .addCase(addNewBankAccount.fulfilled, (state, action) => {
        state.newBankAccount = {
          ...initialState.newBankAccount,
          isBankAccountCreating: false,
          isBankAccountCreated: true,
          bankAccountCreationMsg: action.payload || 'Successfully created the bankAccount.',
        };
      });

       //Bank Account editing
    builder
      .addCase(editBankAccount.pending, (state) => {
        state.editBankAccount = {
          ...initialState.editBankAccount, 
          isEditingBakAccount: true,
          bankAccountEditMsg: 'Loading',
        };
      })
      .addCase(editBankAccount.rejected, (state, action) => {
        state.editBankAccount = {
          ...initialState.editBankAccount,
          isEditingBakAccount: false,
          isEditedBankAccount: false,
          bankAccountEditMsg: action.payload || 'Error occurred while creating the Bank Account.',
        };
      })
      .addCase(editBankAccount.fulfilled, (state, action) => {
        state.editBankAccount = {
          ...initialState.editBankAccount,
          isEditingBakAccount: false,
          isEditedBankAccount: true,
          bankAccountEditMsg: action.payload || 'Successfully updated the Bank Account.',
        };
      });
  },
});

export default bankSlice.reducer;
